import api from './api';

export const getActiveNews = async (params = {}) => {
  const defaultParams = {
    pageNum: "1",
    pageSize: "50",
    searchTerm: "",
    sortBy: "",
    startDate: "2024-03-20T22:10:19.398Z",
    endDate: "2030-03-20T22:10:19.398Z",
    ...params
  };

  try {
    const token = localStorage.getItem('token');
    const response = await api.post('/api/News/GetActiveNews', defaultParams, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error fetching news:', error);
    throw error;
  }
};

export const addNews = async (data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    let pictureBase64 = '';

    // Validate and convert picture to base64 if it exists
    if (data.picture) {
      // Validate image file
      if (!data.picture.type.startsWith('image/')) {
        throw new Error('Geçersiz resim formatı');
      }
      if (data.picture.size > 5 * 1024 * 1024) {
        throw new Error('Resim dosyası 5MB\'dan büyük olamaz');
      }

      pictureBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.picture);
        reader.onload = () => {
          const result = reader.result;
          if (!result) {
            reject(new Error('Resim okunamadı'));
            return;
          }
          resolve(result); // Keep the full base64 string including prefix
        };
        reader.onerror = error => {
          console.error('Resim okuma hatası:', error);
          reject(new Error('Resim okuma sırasında bir hata oluştu'));
        };
      });
    }

    // Validate required fields
    if (!data.header) throw new Error('Başlık alanı zorunludur');
    if (!data.detail) throw new Error('Detay alanı zorunludur');
    if (!pictureBase64) throw new Error('Resim seçilmesi zorunludur');

    const payload = {
      newsCategoryId: data.newsCategoryId || 'af000611-9cf6-e167-676b-46eb0606d4b9',
      newsDate: data.date || new Date().toISOString(),
      header: data.header,
      detail: data.detail,
      shortDetail: data.shortDetail || data.detail?.substring(0, 100),
      pictureUrl: 'temp',  // Required by API, will be updated after upload
      pictureBase64: pictureBase64,
      refererLink: data.refererLink || 'temp'  // Required by API
    };

    console.log('Sending news payload:', {
      ...payload,
      pictureBase64: pictureBase64 ? '(base64 data present)' : '(no picture)'
    });

    const response = await api.post('/api/News/AddNews', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('News added successfully:', response);
    return response;

  } catch (error) {
    if (error.response) {
      console.error('API Error:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      console.error('Network Error - No response received');
    } else {
      console.error('Error:', error.message);
    }
    throw error;
  }
};

export const updateNews = async (data) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Validate required fields
    const requiredFields = ['guid', 'header', 'detail'];
    const missingFields = requiredFields.filter(field => !data[field]);
    if (missingFields.length > 0) {
      throw new Error(`Zorunlu alanlar eksik: ${missingFields.join(', ')}`);
    }

    let pictureBase64 = '';
    let keepExistingPicture = false;

    // Eğer yeni bir resim seçilmemiş ve mevcut bir resim URL'si varsa
    if (!data.picture && (data.pictureUrl || data.existingPictureUrl)) {
      const pictureUrl = data.existingPictureUrl || data.pictureUrl;
      console.log('Mevcut resim korunacak:', pictureUrl);
      keepExistingPicture = true;
      
      // Mevcut resmi base64 olarak göndermeliyiz
      try {
        // Eğer data.pictureBase64 zaten varsa onu kullan
        if (data.pictureBase64) {
          pictureBase64 = data.pictureBase64;
          console.log('Mevcut pictureBase64 kullanılıyor');
        } else {
          // Yoksa boş bir base64 string gönder, API sunucusu keepExistingPicture=true olduğunda
          // bu değeri kullanmayacak ancak bir değer bekliyor olabilir
          pictureBase64 = '';
          console.log('Boş resim kullanılıyor');
        }
      } catch (error) {
        console.error('Resim URL\'sinden base64 dönüşümü sırasında hata:', error);
      }
    }

    // Convert picture to base64 if it's a File object
    if (data.picture && data.picture instanceof File) {
      // Validate image file
      if (!data.picture.type.startsWith('image/')) {
        throw new Error('Geçersiz resim formatı');
      }
      if (data.picture.size > 5 * 1024 * 1024) {
        throw new Error('Resim dosyası 5MB\'dan büyük olamaz');
      }

      pictureBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.picture);
        reader.onload = () => {
          const result = reader.result;
          if (!result) {
            reject(new Error('Resim okunamadı'));
            return;
          }
          resolve(result); // Keep the full base64 string including prefix
        };
        reader.onerror = error => {
          console.error('Resim okuma hatası:', error);
          reject(new Error('Resim okuma sırasında bir hata oluştu'));
        };
      });
    }

    const payload = {
      guid: data.guid,
      newsCategoryId: data.newsCategoryId || 'af000611-9cf6-e167-676b-46eb0606d4b9',
      newsDate: data.date || new Date().toISOString(),
      header: data.header,
      detail: data.detail,
      shortDetail: data.shortDetail || data.detail?.substring(0, 100),
      refererLink: data.refererLink || 'temp',
      pictureBase64: pictureBase64,
      keepExistingPicture: keepExistingPicture,
      existingPictureUrl: data.existingPictureUrl || data.pictureUrl || ''
    };
    
    // Eğer resim seçilmemişse ve mevcut resim de yoksa, boş gönder
    if (!data.picture && !data.pictureUrl && !data.existingPictureUrl) {
      payload.pictureBase64 = '';
      payload.keepExistingPicture = false;
      console.log('Resim seçilmedi ve mevcut resim yok, boş gönderiliyor');
    }

    console.log('Güncellenecek haber verisi:', {
      ...payload,
      pictureBase64: payload.pictureBase64 ? '(base64 data present)' : '(no picture)',
      keepExistingPicture: payload.keepExistingPicture
    });

    const response = await api.post('/api/News/UpdateNews', payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('News updated successfully:', response);
    return response;

  } catch (error) {
    if (error.response) {
      console.error('API Error:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      });
    } else if (error.request) {
      console.error('Network Error - No response received');
    } else {
      console.error('Error:', error.message);
    }
    throw error;
  }
};

export const deleteNews = async (guid) => {
  try {
    const token = localStorage.getItem('token');
    const response = await api.post('/api/News/DeleteNews', { guid }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (error) {
    console.error('Error deleting news:', error);
    throw error;
  }
};
